import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

function ServiceDesFour() {
  return (
    <Container className="p-3">
      <Row style={{ justifyContent: 'center' }} >
        <Row className='mt-3'>
          <Col className='service_des_title' > Retroperitoneum Problems </Col>
        </Row>
        <Row className='mt-3'>
          <Col>
            <p className='service_des_p' > Retroperitoneum can be considered as the posterior part of the peritoneum. </p>
            <p className='service_des_p' >
              Retroperitoneal is a general term to describe structures that are posterior to the peritoneum. Most of these structures are related to abdominal organs. </p>
            <p className='service_des_p' >
              There are two anatomic spaces which lie posterior to the peritoneum: retroperitoneal and subperitoneal space. Retroperitoneal space is located behind all intra-abdominal organs and bounded dorsally by iliac bone, anteriorly by abdominal wall and laterally by parietal pelvic fascia (Figures 1,2). Subperitoneal space is located between the parietal pelvic fascia and sacral vertebrae </p>
          </Col>
        </Row>
        {/* <Row className='mt-3'>
          <Col className='service_des_title'>Retroperitoneum Surgical Procedures </Col>
        </Row>
        <Row className='mt-3'>
          <Col className='service_des_p' >
            <p> Complex hepatic (liver), pancreatic, and biliary surgeries, including, but not limited to: </p>
            <ul>
              <li>Liver resection (major and minor)</li>
              <li> Liver tumor ablation</li>
              <li> Pancreas resection for benign and malignant disease (including Whipple procedure)</li>
              <li> Bile duct resection</li>
              <li> Bile duct repair</li>
              <li> Complex gallbladder resection</li>
            </ul>
            <p> All of these surgical procedures (including major pancreatic surgeries and the Whipple procedure) can be performed in a minimally invasive fashion, when appropriate, through the use of robotic or laparoscopic surgical techniques.</p>
          </Col>
        </Row> */}
      </Row>
    </Container>
  )
}

export default ServiceDesFour